import styled from 'styled-components'

import { Link } from '@subaio/components'

import { Heading1 } from './Heading1'
import { Heading2 } from './Heading2'
import { Heading3 } from './Heading3'
import { Heading4 } from './Heading4'
import { Heading5 } from './Heading5'

export const Anchor = styled(Link)`
	padding-left: 4px;
	opacity: 0;
	visibility: hidden;

	&:hover,
	${Heading1}:hover &,
	${Heading2}:hover &,
	${Heading3}:hover &,
	${Heading4}:hover &,
	${Heading5}:hover & {
		opacity: 1;
		visibility: visible;
	}

	> svg {
		margin-bottom: -1px;
	}
`
